import React from "react";
import SeguimientoMateriales from "./SeguimientoMateriales";

/** Seguimiento de telas sobre el inventario por almacen (ya no por rollo). */
export default function ListadoSeguimientoTelas() {
  return <SeguimientoMateriales tipo="Telas" />;
}
